import React, { Component, Fragment } from 'react'
import SensorsSdk from 'sa-sdk-javascript'
import { setSensors } from '../utils/sensors'

const SERVER = 'https://sensors.binance.cloud/sa?project=dex'
const WEB = 'https://s.datasconsole.com/?project=dex'

export default class Sensorsdata extends Component {
  async componentDidMount() {
    if (typeof window === 'undefined') return
    if (window.location.hostname.includes('localhost')) return
    try {
      const serverUrl = window.location.hostname.includes('localhost') ? '' : SERVER
      const webUrl = window.location.hostname.includes('localhost') ? '' : WEB
      SensorsSdk.init({
        server_url: serverUrl,
        web_url: webUrl,
        heatmap_url: '/static/sensorsdata/heatmap.min.js',
        heatmap: {
          clickmap: 'all',
        },
        name: 'SensorsSdk',
        show_log: false,
      })
      SensorsSdk.quick('autoTrack')
      setSensors(SensorsSdk)
    } catch (error) {
      console.error(error)
    }
  }

  render() {
    return <Fragment>{null}</Fragment>
  }
}
